import { BlockRenderState } from '../enums/block-render-state.js';

export function canDownloadBlockRender(block) {
    // Ready but updated means the render requires a re-render
    if (block.render_state === BlockRenderState.Ready && block.render_created_at && block.render_created_at < block.render_requested_at) {
        return false;
    }

    if (block.render_state === BlockRenderState.Ready) {
        return !!block.render_url;
    }

    return false;
}
